


// import React, { useState } from 'react';
// import { NavLink } from 'react-router-dom';
// import { Wallet, Gift, Home, Headphones, User } from 'lucide-react';
// // import './BottonMenu.css';

// const BottonMenu = () => {
//   const [clickedTab, setClickedTab] = useState(null);

//   const handleTabClick = (tabName) => {
//     setClickedTab(tabName);
//     setTimeout(() => {
//       setClickedTab(null);
//     }, 600); // Reset animation state
//   };

//   return (
//     <div className="bottom_nav_wrapper">
//       <div className="bottom_nav_bar">
        
//         {/* 1. WALLET TAB */}
//         <NavLink
//           exact
//           to="/wallet"
//           className={`nav_item ${clickedTab === 'wallet' ? 'animate_wallet' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('wallet')}
//         >
//           <div className="nav_icon_wrapper">
//             <Wallet className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Wallet</span>
//         </NavLink>

//         {/* 2. REFER TAB */}
//         <NavLink
//           exact
//           to="/refer"
//           className={`nav_item ${clickedTab === 'refer' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('refer')}
//         >
//           <div className="nav_icon_wrapper">
//             <Gift className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Refer</span>
//         </NavLink>

//         {/* 3. CENTER HOME BUTTON */}
//         <div className="center_fab_container">
//           <NavLink
//             exact
//             to="/landing"
//             className="center_fab_button"
//             activeClassName="active_center"
//             onClick={() => handleTabClick('home')}
//           >
//             <div className="fab_pulse_aura"></div>
//             <Home className="center_icon" size={24} />
//           </NavLink>
//         </div>

//         {/* 4. SUPPORT TAB */}
//         <NavLink
//           exact
//           to="/support"
//           className={`nav_item ${clickedTab === 'support' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('support')}
//         >
//           <div className="nav_icon_wrapper">
//             <Headphones className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Support</span>
//         </NavLink>

//         {/* 5. PROFILE TAB */}
//         <NavLink
//           exact
//           to="/Profile"
//           className={`nav_item ${clickedTab === 'profile' ? 'animate_bounce' : ''}`}
//           activeClassName="active"
//           onClick={() => handleTabClick('profile')}
//         >
//           <div className="nav_icon_wrapper">
//             <User className="lucide_icon" size={22} />
//             <span className="active_pill"></span>
//           </div>
//           <span className="nav_label">Profile</span>
//         </NavLink>

//       </div>
//     </div>
//   );
// };

// export default BottonMenu;


import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Wallet, Gift, Home, Headphones, User } from 'lucide-react';
// import '../css/BottonMenu.css';

const BottonMenu = () => {
  const [activeTab, setActiveTab] = useState(null);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setTimeout(() => {
      setActiveTab(null);
    }, 500); // Clears spring trigger class after animation completes
  };

  return (
    <div className="ce_dock_wrapper">
      <div className="ce_dock_container">
        
        {/* 1. WALLET TAB */}
        <NavLink
          exact
          to="/wallet"
          className={`ce_dock_item ${activeTab === 'wallet' ? 'ce_spring_jump' : ''}`}
          activeClassName="ce_active"
          onClick={() => handleTabClick('wallet')}
        >
          <div className="ce_icon_box">
            <Wallet className="ce_icon" size={20} />
            <div className="ce_active_bg_pill"></div>
          </div>
          <span className="ce_label">Wallet</span>
        </NavLink>

        {/* 2. REFER TAB */}
        <NavLink
          exact
          to="/refer"
          className={`ce_dock_item ${activeTab === 'refer' ? 'ce_spring_jump' : ''}`}
          activeClassName="ce_active"
          onClick={() => handleTabClick('refer')}
        >
          <div className="ce_icon_box">
            <Gift className="ce_icon" size={20} />
            <div className="ce_active_bg_pill"></div>
          </div>
          <span className="ce_label">Refer</span>
        </NavLink>

        {/* 3. CENTER HERO HOME BUTTON */}
        <div className="ce_fab_wrapper">
          <NavLink
            exact
            to="/landing"
            className={`ce_fab_btn ${activeTab === 'home' ? 'ce_fab_pop' : ''}`}
            activeClassName="ce_fab_active"
            onClick={() => handleTabClick('home')}
          >
            <div className="ce_fab_ring"></div>
            <div className="ce_fab_inner">
              <Home size={22} className="ce_fab_icon" />
            </div>
          </NavLink>
        </div>

        {/* 4. SUPPORT TAB */}
        <NavLink
          exact
          to="/support"
          className={`ce_dock_item ${activeTab === 'support' ? 'ce_spring_jump' : ''}`}
          activeClassName="ce_active"
          onClick={() => handleTabClick('support')}
        >
          <div className="ce_icon_box">
            <Headphones className="ce_icon" size={20} />
            <div className="ce_active_bg_pill"></div>
          </div>
          <span className="ce_label">Support</span>
        </NavLink>

        {/* 5. PROFILE TAB */}
        <NavLink
          exact
          to="/Profile"
          className={`ce_dock_item ${activeTab === 'profile' ? 'ce_spring_jump' : ''}`}
          activeClassName="ce_active"
          onClick={() => handleTabClick('profile')}
        >
          <div className="ce_icon_box">
            <User className="ce_icon" size={20} />
            <div className="ce_active_bg_pill"></div>
          </div>
          <span className="ce_label">Profile</span>
        </NavLink>

      </div>
    </div>
  );
};

export default BottonMenu;